export default __webpack_public_path__ + "static/B0284-23fdb5fc49672e3f79a9bbf906326931.png";